import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AutosizeModule } from 'ngx-autosize';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { RadarSynthesisModule } from '../../../../../components/radar-synthesis/radar-synthesis.module';
import { PatientNavbarModule } from '../../../../components/navbar/patient-navbar.module';
import { SurveyViewComponent } from './survey-view.component';

@NgModule({
  declarations: [SurveyViewComponent],
  exports: [SurveyViewComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    NgxSliderModule,
    ReactiveFormsModule,
    AutosizeModule,
    PatientNavbarModule,
    RadarSynthesisModule,
    AccordionModule,
  ],
})
export class SurveyViewModule {}
